import { Link } from "react-router-dom";
import "./FuelUp.scss";

export default function FuelUpSuccess() {
  return (
    <main className="fuel-page">
      <section className="fuel-card fuel-card--center">
        <h1>Thank You</h1>
        <p>
          Your support helps keep Mini Miles Adventures moving down the slower
          roads.
        </p>

        <Link className="fuel-primary-link" to="/watch">
          Watch Recent Journeys
        </Link>
      </section>
    </main>
  );
}
